'use strict';

/**
 * @name train
 */

exports.gotoOrderDetail = require('./goto-order-detail.js');
exports.selectDate = require('./select-date.js');
exports.selectStation = require('./select-station.js');
exports.timeTable = require('./time-table.js');

exports.selectDateStudent = require('./select-date-student.js');
exports.selectDateRush = require('./select-date-rush.js');
exports.timeRange = require('./time-range.js');
exports.gotoOrderList = require('./goto-order-list.js');
exports.multiSelect = require('./multi-select.js');
exports.selectTrains = require('./select-trains.js');
exports.ringtone = require('./ringtone.js');
exports.vibrate = require('./vibrate.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/index.js
// module id = 630
// module chunks = 0